import { render, staticRenderFns } from "./InventoryReservationDashboard.vue?vue&type=template&id=577d4615&scoped=true"
import script from "./InventoryReservationDashboard.vue?vue&type=script&lang=js"
export * from "./InventoryReservationDashboard.vue?vue&type=script&lang=js"
import style0 from "./InventoryReservationDashboard.vue?vue&type=style&index=0&id=577d4615&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577d4615",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('577d4615')) {
      api.createRecord('577d4615', component.options)
    } else {
      api.reload('577d4615', component.options)
    }
    module.hot.accept("./InventoryReservationDashboard.vue?vue&type=template&id=577d4615&scoped=true", function () {
      api.rerender('577d4615', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inventoryReservation/InventoryReservationDashboard.vue"
export default component.exports